module.exports = __webpack_public_path__ + "static/media/brand13.672061bd.png";